import request from '../../../helpers/request';

const downloadCounterpartyAttachment = async (
  fileName,
  counterpartyId,
  name
) => {
  const response = await request.get(
    `/RentPlace/counterparty/${counterpartyId}/attachment`,
    {
      fileName,
    }
  );
  if (response) {
    let data = Buffer.from(response, 'base64');
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
  }
};

export default downloadCounterpartyAttachment;
